export const FIELDS_WITHOUT_CHARACTER_COUNT = new Set([
  'firstName',
  'lastName',
  'email',
]);
